<template>
  <Avatar
    v-if="chat.typeName === 'one-to-one' && receiver"
    :user="receiver"
    :size="size"
    :isShowOnline="isShowOnline"
  />
  <AvatarGroup
    v-else-if="chat.typeName === 'group'"
    :chat="chat"
    :size="size"
  />
</template>

<script>
import Avatar from '@/components/Avatar'
import AvatarGroup from '@/components/AvatarGroup'

export default {
  name: 'chat-avatar',
  components: {
    Avatar,
    AvatarGroup
  },
  props: {
    chat: {
      type: Object,
      required: true
    },
    chatFullVersion: Object,
    receiver: Object,
    size: Number,
    isShowOnline: Boolean
  }
}
</script>
